export default __webpack_public_path__ + "static/media/logo.db47f23c.svg";